import siteApi from 'common/api/SiteApi.ts'
import {EntityData, ListEntityData} from 'common/api/entities.tsx'
import {OwnedEntitySelector} from 'common/components/reloadable/OwnedEntitySelector.tsx'
import React from 'react'

const findEntity = (id: number) => {
    return siteApi.view(id)
}

interface SiteSelectorProps {
    value?: number | number[]
    onChange?: (value?: number | number[]) => void
    searchEntities?: (search: string, page: number, size: number, advertiserId?: number) => Promise<ListEntityData>
    loadEntity?: (id: number) => Promise<EntityData>
    style?: React.CSSProperties
    placeholder?: string
    disabled?: boolean
    errorText?: string
    multiple?: boolean
    publisherId?: number;
}

const searchEntities = (search: string, pageSize: number, page: number, publisherId?: number) => {
    return siteApi
        .list('name', 'asc', search, undefined, publisherId, {
            query: { pageSize, page },
        })
}

export const SiteSelector: React.FC<SiteSelectorProps> = ({ value, onChange, style, disabled, placeholder, multiple, publisherId }) => {
    return (
        <OwnedEntitySelector
            ownerId={publisherId}
            value={value}
            onChange={onChange}
            loadEntity={findEntity}
            searchEntities={searchEntities}
            placeholder={placeholder}
            disabled={disabled}
            style={style}
            errorText="Can't load Site"
            multiple={multiple}
        />
    )
}
